import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { getUserState } from 'hooks/useUserState'
import { isTenantSmava } from 'utils/url'
import type RootStore from 'stores/RootStore'
import type { GateContext } from './gates.types'

// Pure function — for config-level usage
export function buildGateContext(rootStore: RootStore): GateContext {
  const tenant: Tenant = isTenantSmava() ? 'smava' : 'ffg'
  const { traversal } = rootStore

  return {
    ...getUserState(rootStore),
    experimentData: rootStore.experimentData,
    tenant,
    isDacSkipped: rootStore.traversalSession.isDacSkipped,
    amount: traversal.data?.common?.amount ?? 0,
    primaryIncome: traversal.data?.debtors?.primary?.income?.primary ?? 0,
    configName: rootStore.page.config.name
  }
}

// Hook — reactive via MobX observer(), NOT React Context
export function useGateContext(): GateContext {
  const { rootStore } = useRootStore()
  return buildGateContext(rootStore)
}
